import subordinateList from '../rw-subordinates/reducers/subordinate-list-combine';

export default subordinateList;



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/subordinate-list.reducer.js